var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-base',{attrs:{"title":"Predefined fields","items":_vm.preset_fq,"key-name":'name'},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('icon',{staticClass:"mr-1",attrs:{"icon":item.icon}}),_vm._v("\n        "+_vm._s(item.name)+"\n    ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }